<template>
  <Error
    title="ページにアクセスできません"
    lead="会員証QRコードの有効期限が切れています"
  >
    <template #default>
      更新されたQRコードをもう一度読み取ってください。
    </template>
  </Error>
</template>

<script>
import Error from '@/components/Error.vue'

export default {
  navbar: false,
  components: {
    Error
  },
  metaInfo() {
    return {
      title: '',
      bodyAttrs: { class: 'error' }
    }
  }
}
</script>
